import { g as a } from "./_baseGetTag-D86WGQCZ.js";
import { r as d } from "./toString-Cs_Mc-g1.js";
var r, u;
function q() {
  if (u) return r;
  u = 1;
  var e = d(), i = 0;
  function n(t) {
    var o = ++i;
    return e(t) + o;
  }
  return r = n, r;
}
var s = q();
const I = /* @__PURE__ */ a(s);
export {
  I as u
};
